import { Flex, Text } from "@chakra-ui/react";
import { format } from "date-fns";
import { NewOrderEarSide, useNewOrderStore } from "../../../stores/order.store";
import { CommandStatus } from "../../../types/command.types";
import { usePatientCommands } from "../../../hooks/patients.hooks";
import { LeftEar } from "./EarIcons";
import BrandFullCheckIcon from "../../../components/icons/BrandFullCheckIcon";
import { EarSectionSpacer } from "./EarSectionSpacer";
import { CardSelectable } from "./CardSelectable";
import Input from "../../../components/inputs/Input";

export const EarSectionPreviousCommandLeft = () => {
	const { hasLeftEar, enableEar } = useNewOrderStore();
	const { patient } = useNewOrderStore();
	const { reworkCommand, reworkCommandOld, setReworkCommand } =
		useNewOrderStore();
	const commands = usePatientCommands(patient?.id)(
		1,
		5,
		undefined,
		{ not_status: CommandStatus.DRAFT },
		["-createdAt"],
	);

	return (
		<Flex
			direction="column"
			justifyContent="center"
			border="solid 1px"
			borderColor="gray.200"
			borderRadius="xl"
			p={4}
			bgColor={hasLeftEar ? "#EFF6FF" : undefined}
		>
			<Flex
				position="relative"
				direction="column"
				gap={4}
				alignItems="center"
				onClick={() => {
					if (reworkCommand === undefined) {
						enableEar(NewOrderEarSide.LEFT, !hasLeftEar);
					} else {
						const reworkCommandDraft = reworkCommand.draft;
						if (reworkCommandDraft?.hasLeftEar === true) {
							enableEar(NewOrderEarSide.LEFT, !hasLeftEar);
						}
					}
				}}
			>
				<LeftEar />
				Oreille gauche
				{hasLeftEar && (
					<Flex className="absolute top-2 right-4 flex gap-4 items-center">
						<Text>Déselectionner l'oreille</Text>
						<BrandFullCheckIcon
							w="24px"
							h="24px"
							className="text-brand-600"
							color="text-brand-600"
						/>
					</Flex>
				)}
				{!hasLeftEar && (
					<Flex className="absolute top-2 right-4 flex gap-4 items-center">
						<Text>Sélectionner l'oreille</Text>
						<div className="w-6 h-6 rounded-full border! border-gray-200"></div>
					</Flex>
				)}
			</Flex>

			<EarSectionSpacer py={2} />
			{hasLeftEar && (
				<Flex direction="column" gap={8} pt={8} alignItems={"center"}>
					<Text lineHeight="36px" fontSize="24px" fontWeight="600">
						Sélectionner la commande concernée
					</Text>

					{commands &&
						Array.isArray(commands.data) &&
						commands.data.map((command) => (
							<CardSelectable
								key={command.id}
								onClick={() => setReworkCommand(command)}
								activated={command.id === reworkCommand?.id}
								inline
							>
								<Flex
									direction="row"
									gap={4}
									justifyContent={"center"}
									alignItems={"center"}
								>
									<Text
										lineHeight="18px"
										fontSize="12px"
										fontWeight="400"
										color="gray.500"
									>
										Commande
									</Text>
									<Text
										lineHeight="27px"
										fontSize="18px"
										fontWeight="600"
										color="gray.700"
									>
										{command.exposedId}
									</Text>
									<Text lineHeight="21px" fontSize="14px" fontWeight="400">
										{format(command.createdAt, "dd/MM/yyyy")}
									</Text>
								</Flex>
							</CardSelectable>
						))}

					<EarSectionSpacer content="ou" bgColor="#EFF6FF" />

					<Text
						w="33rem"
						textAlign="center"
						lineHeight="36px"
						fontSize="24px"
						fontWeight="600"
					>
						Si commande antérieure alors entrez le numéro de la commande
						concernée
					</Text>
					<Text
						w="33rem"
						textAlign="center"
						lineHeight="24px"
						fontSize="16px"
						fontWeight="400"
					>
						Si la commande est indisponible dans la liste alors veuillez rentrer
						le numéro de la commande concernée. ex: 2022-15608.
					</Text>

					<Input
						name="orderId"
						placeholder="Numéro de la commande"
						value={reworkCommandOld}
						setValue={setReworkCommand}
					/>
				</Flex>
			)}
		</Flex>
	);
};
